import { createContext, useContext, useEffect, useState } from "react";

const LangCtx = createContext({ lang: "es", setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ce-lang") || "es");
  useEffect(() => {
    localStorage.setItem("ce-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang }}>{children}</LangCtx.Provider>;
};

export const useLang = () => {
  const { lang, setLang } = useContext(LangCtx);
  const tr = (v) => (v && typeof v === "object" && !Array.isArray(v) && "es" in v ? v[lang] : v);
  return { lang, setLang, tr };
};
